<template>
  <div class="home">
    <v-row justify="center">
      <v-col
        cols="12"
        sm="8"
        md="6"
        xl="3"
      >
        <v-alert
          outlined
          border="top"
          color="primary"
        >
          Booking Ref: {{ paymentLink.booking.ref }}
        </v-alert>
        <template v-if="paymentLink.id && !paymentLink.is_paid">
          <p>Hi {{ paymentLink.customer.first_name }}, please use the form below to enter you payment details.</p>

          <v-form
            ref="form"
            v-model="validForm"
          >
            <div class="mb-4">
              <h3>Secure Payment</h3>
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-visa']" />
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-mastercard']" />
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-jcb']" />
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-discover']" />
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-diners-club']" />
              <font-awesome-icon class="mr-1" size="lg" :icon="['fab', 'cc-amex']" />
            </div>

            <PaymentForm
              v-if="paymentLink.id"
              ref="paymentForm"
              :stripe-is-complete.sync="stripeIsComplete"
              :loading.sync="loading"
              :paymentLink="paymentLink"
              @paymentComplete="handleCompletePayment"
            />

            <v-btn
              :loading="loading"
              block
              color="primary"
              large
              @click="submitForm">
              {{ paymentLink.amount ? `Pay £${paymentLink.amount.toFixed(2)}` : 'Add Payment Method' }}<v-icon right dark>mdi-chevron-right</v-icon>
            </v-btn>
          </v-form>
        </template>

        <template v-else>
          <v-alert
            class="mt-2"
            outlined
            border="top"
            type="success"
          >
            Payment already made, thank you!
          </v-alert>
        </template>

        <v-alert
          v-if="error.message"
          class="mt-2"
          outlined
          border="top"
          type="error"
        >
          {{ error.message }}
        </v-alert>

      </v-col>
    </v-row>
  </div>
</template>
<script>
import PaymentForm from '@/components/PaymentForm'
import axios from 'axios'
export default {
  name: 'Home',

  props: {
    paymentLinkId: {
      type: String,
      required: true
    },
    apiSignature: {
      type: String,
      required: true
    }
  },

  components: {
    PaymentForm
  },

  data () {
    return {
      stripeIsComplete: false,
      loading: false,
      validForm: true,
      error: {},
      paymentLink: {
        booking: {},
        customer: {}
      }
    }
  },

  mounted () {
    this.getPaymentLink()
  },

  methods: {
    getPaymentLink () {
      this.loading = true
      const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL
      })
      axiosInstance.defaults.headers.common['Client-Id'] = process.env.VUE_APP_CLIENT_ID
      axiosInstance.get(`/api/payment-links/${this.paymentLinkId}/signed?signature=${this.apiSignature}`)
        .then(({ data: { data: paymentLink } }) => {
          this.paymentLink = paymentLink
          this.error = {}
        })
        .catch(({ response: { data: error } }) => {
          this.error = error
        })
        .finally(() => { this.loading = false })
    },

    submitForm () {
      var valid = this.$refs.form.validate()
      if (valid || !this.stripeIsComplete) {
        this.$refs.paymentForm.handlePayment()
      }
    },

    handleCompletePayment (data) {
      this.$router.push({ name: 'complete', params: { paymentLinkId: this.paymentLinkId, apiSignature: this.apiSignature } })
    }
  }
}
</script>
